"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deLocaleData = require("i18next-icu/locale-data/de");
exports.default = deLocaleData;
//# sourceMappingURL=de.js.map